const ProfileGroupIntegrated = ({language , token}) => {
  const newProfileGroupIframe = "https:" +
  window.process.env.URL_Profile_Group
  +  "?lang=" + language + "&token=" +
    token
  return (
    <iframe
      id="iframe_profileGroup_display"
      src={newProfileGroupIframe}
      allowFullScreen
      frameBorder={"0"}
      style={{ width: '100%', height: '100%', overflow: 'hidden' }}
    />
  )
}

export default ProfileGroupIntegrated